// @flow

import type {
  AuthState,
  RequestResetPasswordOperation,
} from 'hfty-auth/types'

import type {
  Action,
  Dispatch,
} from 'fc-flow-types/redux'

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// components
import Dialog from '../components/EmailInUseDialog'

// Selectors, Action Creations, Operator
import { requestResetPassword } from 'fc-auth/src/actions'
import { requestResetOperation$ } from 'hfty-auth'

type Actions = {
  actions: {
    requestResetPassword: Action,
  }
}

const mapStateToProps = function<S: { auth: AuthState } > (state: S): RequestResetPasswordOperation {
  return {
    operation: requestResetOperation$(state),
  }
}

const mapDispatchToProps = function (dispatch: Dispatch<*>): Actions {
  return {
    actions: bindActionCreators({
      onSubmit: requestResetPassword,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dialog)
